<template>
  <div class="vector" v-if="vector.count || vector.default">
    <div class="buttons has-addons is-regular-16-000-42">
      <!-- :class="{'is-info is-outlined active':isActive}" -->
      <span @click="applyClass(vector.num_shortcut)" >
        <i class="fa fa-circle" :style="{'color':vector.color}"></i>
      </span>
      <span
        :class="{'active':isActive}"
        @click="toggleVectors(vector.class_id)"
        class="class_name is-small"
        :title="vector.description"
      >{{ truncateStr(vector.description) }}</span>
      <span class=" class_count">{{vector.count}}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      isActive: true
    };
  },
  props: ["vector", "is_group_active"],
  computed: {
    ...mapState(["draw", "features", "active_layer", "vectors"]),
    shortcuts() {
      let arr = [];
      Object.values(this.vectors).forEach(v => {
        arr[v.num_shortcut] = [v.class_id, v.class_name];
      });
      return arr;
    }
  },
  created: function() {
    if (this.vector.class_name === "table") this.isActive = false;
  },
  methods: {
    ...mapMutations(["FILTER_LAYER_VECTOR"]),
    toggleVectors(class_id) {
      this.isActive = !this.isActive;
      this.FILTER_LAYER_VECTOR({ class_id: class_id, active: this.isActive });
    },
    truncateStr(name) {
      return _.truncate(name || "NA", {
        length: 24,
        separator: " "
      });
    },
    applyClass(num) {
      if (this.shortcuts[num]) {
        for (let id of this.draw.getSelectedIds()) {
          this.draw.setFeatureProperty(id, "class_id", this.shortcuts[num][0]);
          this.draw.setFeatureProperty(
            id,
            "class_name",
            this.shortcuts[num][1]
          );
        }
      }
      this.$store.dispatch("update_vector_count");
    }
  },
  watch: {
    is_group_active: function(val) {
      this.toggleVectors(this.vector.class_id);
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes slide-left {
  from {
    margin-left: 100%;
    width: 300%;
  }

  to {
    margin-left: 0%;
    width: 100%;
  }
}
.vector {
  display: flex;
  margin-bottom: 0.6rem;
  font-size: 14px;
  font-family: Barlow;
  .class_name {
    cursor: pointer;
    text-align: left;
    margin-left:1rem; 
    font-weight: 400;
    text-transform: capitalize;
    text-decoration: line-through;
    position: relative;
    justify-content: left;
    width: 175px;
    overflow: hidden;
    z-index: 1;
    @media (max-width: 900px) {
      width: 100px;
    }
    i {
      visibility: visible;
      position: absolute;
      z-index: 1;
      right: 3px;
    }
    .fa-edit-btn {
      right: 1rem;
    }
    &.active {
      // border-left: 3px solid green;
      color: #171e48;
      text-decoration: none;
    }
  }
  .active-feature-type {
    background: #343434;
    color: #fff;
  }
  .class_count {
    width: 50px;
    font-family: Barlow-medium;
    font-size: 16px;
    color: #171e48;
  }
}
</style>

